'use client';
import styled from 'styled-components';

export const StyledCTAGroupComponent = styled.div`
  margin: ${props => props.theme.spacing(4, 0)};
  display: grid;
  grid-template-columns: 1fr;
  gap: ${props => props.theme.spacing(props.$gap ? props.$gap : 4)};

  @media ${props => props.theme.tablet} {
    grid-template-columns: repeat(${props => props.$buttonsPerRow || 2}, auto);
    justify-content: ${props => {
      switch (props.$alignment) {
        case 'left':
          return 'flex-start';
        case 'right':
          return 'flex-end';
        case 'center':
        default:
          return 'center';
      }
    }};
  }
`;

export const CTAButtonWrapper = styled.div`
  ${props => props.theme.getFocusOutline()};
  width: ${props => (props.$fullWidth ? '100%' : 'max-content')};
`;
